import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import useWindowSize from '@shared/hooks/windowSize'
import StaticBanner from '@shared/components/staticBanner'
import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'
// import WordleWidget from '@shared/components/wordleWidget'
// import Formula1Widget from '@shared/components/widgets/f1Widget'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'
import WidgetFirstCard from '@shared/components/widgets/widgetFirst'
import { getImgURL } from '@shared-submodule/utils'
import { WIDGET } from '@shared-submodule/sm-constants'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
// const WTC2023 = dynamic(() => import('@shared/components/widgets/wtc2023'), { ssr: false })
const ScorecardSlider = dynamic(() => import('@shared/components/scorecardSlider'))
const Layout = dynamic(() => import('@shared/components/layout'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

function HomePageContent({ articles, children, miniScorecard, fantasyTips, seoData, footballNews, tennisNews, trendingNews }) {
  const { isLoaded } = useOnMouseAndScroll()
  const [width] = useWindowSize()

  const footballNewsData = footballNews?.map(news => ({
    title: news?.sTitle,
    publishDate: news?.dPublishDate,
    sSlug: news?.oSeo?.sSlug,
    image: {
      url: getImgURL(news?.oImg?.sUrl),
      altText: news?.oImg?.sText
    }
  })) || []

  const tennisNewsData = tennisNews?.map(news => ({
    title: news?.sTitle,
    publishDate: news?.dPublishDate,
    sSlug: news?.oSeo?.sSlug,
    image: {
      url: getImgURL(news?.oImg?.sUrl),
      altText: news?.oImg?.sText
    }
  })) || []

  const trendingNewsData = trendingNews?.map(news => ({
    title: news?.sTitle,
    description: news?.sDescription,
    publishDate: news?.dPublishDate,
    sSlug: news?.oSeo?.sSlug,
    image: {
      url: getImgURL(news?.oImg?.sUrl),
      altText: news?.oImg?.sText
    }
  })) || []

  function getMetaDetail() {
    return {
      oSeo: {
        sTitle: seoData?.sTitle,
        sDescription: seoData?.sDescription,
        aKeywords: seoData?.aKeywords
      }
    }
  }

  const { addTop, addRight, addLeft, mobSm } = reviveAdData
  return (
    <Layout data={getMetaDetail()}>
      <ScorecardSlider isSeriesTitle data={miniScorecard} eclipseBlur={true} />
      <ATSAds />
      <div className="pt-0">
        <Container className={styles.homeContainer}>
          <div className="w-full d-none d-md-flex justify-content-center ">
            <ReviveAds {...addTop} />
          </div>
          <div className="w-full d-flex d-md-none justify-content-center ">
            <ReviveAds {...mobSm} />
          </div>
          <Row>
            <Col lg={8} className={styles.centerContent}>
              {children}
              {/* {width > 1000 && articles?.length > 0 && (
                <ReviveAds {...addBottom} className={'my-3'}/>
              )}
              {width < 720 && (
                <ReviveAds {...addRight} className={'my-3'}/>
              )} */}
            </Col>
            {width > 990 && (
              <Col lg={4} className={`${styles.commonSidebar} common-sidebar bt-width d-none d-lg-block`}>
                <>
                  {/* Figma order */}
                  <AllWidget show={true} type={WIDGET.didYouKnow} />
                  <AllWidget show={true} type={WIDGET.upcomingMatches} />
                  <WidgetFirstCard headerTitle="Trending News" viewAllLink="/cricket-news" data={trendingNewsData} cardInternalLink={true} viewAllInternalLink={true} variant="text"/>
                  <AllWidget show={true} type={WIDGET.prioritySeries} />
                  <AllWidget show={true} type={WIDGET.ranking} />
                  <WidgetFirstCard headerTitle="Football News" viewAllLink="/football/news" data={footballNewsData} cardInternalLink={true}/>
                  <WidgetFirstCard headerTitle="Tennis News" viewAllLink="/tennis/news" data={tennisNewsData} cardInternalLink={true}/>
                  {/* <Formula1Widget/> */}
                  {/* <WordleWidget className='mt-0' /> */}
                  <ReviveAds {...addLeft} className={'mt-0 mb-4'}/>
                  {/* <WTC2023 /> */}
                  <div className='d-flex justify-content-center'>
                    <ReviveAds {...addLeft} />
                  </div>
                  <ATSAds />
                  <ReviveAds {...addRight} className={'mt-0'}/>
                  {isLoaded && <StaticBanner isLeft />}
                </>
              </Col>
            )}
          </Row>
          {/* <a href="https://o2o.to/i/0MacsN" target="_blank" rel="noopener noreferrer nofollow">
            <div className={`d-md-flex d-none justify-content-center align-items-center ${styles.downloadBanner}`}></div>
          </a> */}
        </Container>
      </div>
    </Layout>
  )
}
HomePageContent.propTypes = {
  children: PropTypes.object,
  articles: PropTypes.array,
  miniScorecard: PropTypes.array,
  fantasyTips: PropTypes.object,
  seoData: PropTypes.object,
  footballNews: PropTypes.array,
  tennisNews: PropTypes.array,
  trendingNews: PropTypes.array
}
export default HomePageContent
